// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fr-box.fr-basic .fr-element {
  padding: 10px !important;
}
.fr-box.fr-basic .fr-element.fr-view {
  font-family: avenir-roman, sans-serif;
}
.fr-box.fr-basic {
  border-radius: 0px !important;
  -webkit-border-radius: 0px !important;
}
.fr-box.fr-basic .fr-wrapper {
  width: 100%;
}
.fr-btn-grp {
  margin: 0px !important;
}
.fr-command.fr-btn {
  height: 30px !important;
}
.fr-view a {
  color: #0894CF;
}
.fr-view a:hover {
  text-decoration: underline;
}
.fr-newline {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.fr-second-toolbar {
  display: none;
}
.fr-toolbar {
  border-radius: 0px !important;
  -webkit-border-radius: 0px !important;
  border: 0px !important;
  height: 18px !important;
}
.fr-toolbar .fr-command.fr-btn svg {
  margin: 5px 4px !important;
}
.fr-toolbar .fr-command.fr-btn svg.fr-svg {
  height: 18px !important;
}
.fr-wrapper {
  border: 0px !important;
}
/* Link styles */
.fr-view a {
  cursor: pointer;
  color: #0066cc;
  text-decoration: none;
}
.fr-view a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/froala.less"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ;AAEA;EACI,qCAAA;AAAJ;AAGA;EACI,6BAAA;EACA,qCAAA;AADJ;AAIA;EACI,WAAA;AAFJ;AAKA;EACI,sBAAA;AAHJ;AAMA;EACI,uBAAA;AAJJ;AAOA;EACI,cAAA;AALJ;AAQA;EACI,0BAAA;AANJ;AASA;EACI,2BAAA;EACA,4BAAA;AAPJ;AAUA;EACI,aAAA;AARJ;AAWA;EACI,6BAAA;EACA,qCAAA;EACA,sBAAA;EACA,uBAAA;AATJ;AAYA;EACI,0BAAA;AAVJ;AAaA;EACI,uBAAA;AAXJ;AAcA;EACI,sBAAA;AAZJ;AACA,gBAAgB;AAehB;EAEM,eAAA;EACA,cAAA;EACA,qBAAA;AAdN;AAgBM;EACE,0BAAA;AAdR","sourcesContent":[".fr-box.fr-basic .fr-element {\n    padding: 10px !important\n}\n\n.fr-box.fr-basic .fr-element.fr-view {\n    font-family: avenir-roman, sans-serif;\n}\n\n.fr-box.fr-basic {\n    border-radius: 0px !important;\n    -webkit-border-radius: 0px !important;\n}\n\n.fr-box.fr-basic .fr-wrapper {\n    width: 100%;\n}\n\n.fr-btn-grp {\n    margin: 0px !important;\n}\n\n.fr-command.fr-btn {\n    height: 30px !important;\n}\n\n.fr-view a {\n    color: #0894CF;\n}\n\n.fr-view a:hover {\n    text-decoration: underline;\n}\n\n.fr-newline {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n}\n\n.fr-second-toolbar {\n    display: none;\n}\n\n.fr-toolbar {\n    border-radius: 0px !important;\n    -webkit-border-radius: 0px !important;\n    border: 0px !important;\n    height: 18px !important\n}\n\n.fr-toolbar .fr-command.fr-btn svg {\n    margin: 5px 4px !important;\n}\n\n.fr-toolbar .fr-command.fr-btn svg.fr-svg {\n    height: 18px !important\n}\n\n.fr-wrapper {\n    border: 0px !important;\n}\n\n/* Link styles */\n.fr-view {\n    a {\n      cursor: pointer;\n      color: #0066cc;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
